const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay/classic');
const get = require('lodash.get');
const ContextComponent = require('../../../global/components/ContextComponent');
const { CallDealerModal } = require('dibs-buyer-initiate-call');
const authModalLoader = require('dibs-buyer-layout/src/utils/AuthModalLoader').default;
const favoriteActions = require('../../../global/actions/favoritesActions');
const FavoriteModel = require('bunsen/models/identity/Favorite');
const tracking = require('dibs-tracking');
import { FormattedMessage } from 'react-intl';
import PhoneIcon from 'dibs-vg/dist/react/phone';
require('dibs-elements/dist/buyer.css');

class CallDealerButton extends ContextComponent {
    constructor(props) {
        super(props);
        this.state = { callDealerIsOpened: false };
        this.onCallDealerClick = this.onCallDealerClick.bind(this);
        this.onCallDealerModalClose = this.onCallDealerModalClose.bind(this);
        this.onCallDealerAuthRequired = this.onCallDealerAuthRequired.bind(this);
        this.onCallDealerModalFollow = this.onCallDealerModalFollow.bind(this);
    }

    componentDidUpdate(prevProps) {
        // defer auth callback until after relay has refetched,
        // otherwise the props passed to CallDealerModal will be null
        if (!get(prevProps, 'item') && get(this.props, 'item') && this.authCallback) {
            this.authCallback();
            this.authCallback = null;
        }
    }

    onCallDealerClick() {
        const { callDealerIsOpened } = this.state;
        this.setState({ callDealerIsOpened: !callDealerIsOpened });

        tracking.trackEvent({
            value: '0',
            category: 'contact dealer',
            action: 'call dealer clicked',
            label: 'more from dealer',
        });
    }

    onCallDealerModalClose() {
        this.setState({ callDealerIsOpened: false });
    }

    onCallDealerAuthRequired(onAuthSuccess, onAuthFailure) {
        this.setState({ callDealerIsOpened: false });
        authModalLoader
            .show({
                action: authModalLoader.constants.REGISTER,
                flow: authModalLoader.constants.CONTACT_DEALER_CALL_FLOW,
                ga: {
                    label: 'initiated call to dealer',
                },
            })
            .then(({ user, err }) => {
                if (err) {
                    onAuthFailure();
                    return;
                }
                // delay the execution of the callback until the top-level PdpLayout relay query
                // has time to refetch with the updated userId
                this.authCallback = () => onAuthSuccess(user.userId);
                this.setState({ callDealerIsOpened: true });
            });
    }

    onCallDealerModalFollow() {
        const { dealerPk, page } = this.props;
        const payload = {
            type: FavoriteModel.TYPE_DEALER,
            primaryKey: dealerPk,
            page,
        };
        this.context.executeAction(favoriteActions.saveToFavorites, payload);
        this.setState({ callDealerIsOpened: false });
    }

    render() {
        const { callDealerIsOpened } = this.state;
        const { userId, hasUserId, viewer, item, itemId } = this.props;
        const seller = get(item, 'seller', null);
        const conversation = get(viewer, 'buyerItemConversation', null);

        return (
            <div>
                <div className="call-seller-cta" onClick={this.onCallDealerClick}>
                    <PhoneIcon className="call-seller-cta-icon" />
                    <FormattedMessage
                        id="pdp.ContactDealerMessage.callSellerCTA"
                        defaultMessage="Call seller through 1stdibs"
                    />
                </div>
                <CallDealerModal
                    userId={userId}
                    hasUserId={hasUserId}
                    viewer={viewer}
                    conversation={conversation}
                    item={item}
                    itemId={itemId}
                    seller={seller}
                    isOpened={callDealerIsOpened}
                    location="pdp"
                    onAuthRequired={this.onCallDealerAuthRequired}
                    onClose={this.onCallDealerModalClose}
                    onFollowDealer={this.onCallDealerModalFollow}
                />
            </div>
        );
    }
}

CallDealerButton.propTypes = {
    userId: PropTypes.string,
    hasUserId: PropTypes.bool.isRequired,
    dealerPk: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    viewer: PropTypes.object,
    item: PropTypes.object,
    itemId: PropTypes.string,
    renderCtaAsLink: PropTypes.bool,
};

module.exports = Relay.createContainer(CallDealerButton, {
    initialVariables: {
        hasUserId: false,
        userId: null,
        itemId: null,
    },
    fragments: {
        item: ({ userId, hasUserId }) => Relay.QL`
            fragment on Item {
                ${CallDealerModal.getFragment('item', { userId, hasUserId })}
                seller {
                    ${CallDealerModal.getFragment('seller', { userId, hasUserId })}
                }
            }
        `,
        viewer: ({ userId, hasUserId }) => Relay.QL`
            fragment on Viewer {
                ${CallDealerModal.getFragment('viewer', { userId, hasUserId })}
                buyerItemConversation(buyerId: $userId, itemId: $itemId) @include(if: $hasUserId) {
                    ${CallDealerModal.getFragment('conversation', { userId, hasUserId })}
                }
            }
        `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/CallDealerButton.jsx